import React from 'react';
import { randomKey, testEnv } from '../functions/common';

//* This adds a text snippet above most elements on the page in dev mode,
//* when the GATSBY_DEV_MODE variable is set to 'true'.
//* This stuff should never appear on a non-dev site.

export const DevAids = ({ node, pageLinks = false }) => {
  const env = testEnv(),
    apiDomain = process.env.GATSBY_DRUPAL_DOMAIN;

  if (typeof node !== 'object') return <React.Fragment key={randomKey()}></React.Fragment>;

  const id = node.internal?.id || null,
    type = node.type || node.internal?.type || null,
    drupalId = node.drupal_id || null;

  /* overflow:hidden helped to test mobile views where uuid was causing
  /* width layout issues.
  */
  const devAids =
    env.devMode === true ? (
      pageLinks === false ? (
        <pre key={id} style={{ overflow: 'hidden' }}>
          Gatsby node type: <strong>{type || 'Unknown'}</strong>
          <br />
          {(id && `Gatsby ID: ${id}`) ||
            (drupalId && `Drupal UUID: ${drupalId}`) ||
            'No Gatsby ID or Drupal UUID found'}
        </pre>
      ) : (
        <ul className="dev-aids">
          <li>Drupal UUID: {node.drupal_id}</li>
          <li>
            Node ID:{' '}
            <a href={`${apiDomain}/node/${node.drupal_internal__nid}/edit`} target="_blank">
              {node.drupal_internal__nid}
            </a>
          </li>
          {node.field_legacy_url && (
            <li>
              Source page: <a href={node.field_legacy_url}>{node.field_legacy_url}</a>
            </li>
          )}
        </ul>
      )
    ) : (
      <React.Fragment key={id}></React.Fragment>
    );
  return devAids;
};
